<p-confirmDialog key="panicalerttopic" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-item">
		<div>
			<label>School</label>
		</div>

		<div style="margin-left: 10px">
			<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading() == true"> </caass-schoolselector>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Topic</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Topic</button>
		<button [disabled]="IsLoading() == true" class="btn btn-warning" style="margin-left: 5px" (click)="onToggle()">{{ ToggleText }}</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete Topic</button>

		<img class="info-img" (click)="onShowInfo()" src="assets/images/info-24.png" />

		<label class="TitleLabel">Topics</label>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="ShowInfo == true ? 'block' : 'none'">
		<label>Overview:</label><br />
		<label>&#9900; The Staff Portal App allows users to press a button and send out an alert notification</label><br />
		<label>&#9900; Normally the alert goes to everyone. If you double press the Alert Button you can pick a group to notify</label><br />
		<label>&#9900; Topics are the groups that you can pick from, Ex. Security Guards, Principal, Teachers, etc.</label><br />
		<label>&#9900; People can be assigned to Topics and they will get any notifications sent to that group</label><br />
		<br />
		<label>&#9900; Add Topic: Create a new topic for the selected school</label><br />
		<label>&#9900; Edit Topic: Edit the name and description of a Topic</label><br />
		<label>&#9900; Deactivate Topic: Inactive Topics won't show up in the Staff App when you pick a topic to notify</label><br />
		<label>&#9900; Delete Topic: Removes the Topic and list of people assigned to it</label><br />
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPortalPanicAlertTopic"
		[loading]="TableLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPortalPanicAlertTopic"
		dataKey="PortalPanicAlertTopicID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--TopicCD-->
				<th>
					<p-columnFilter type="text" field="TopicCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--TopicDesc-->
				<th>
					<p-columnFilter type="text" field="TopicDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--c_dateDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="c_dateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--PersonCount-->
				<th>
					<p-columnFilter type="text" field="PersonCount" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="TopicCD">Topic<p-sortIcon field="TopicCD"></p-sortIcon></th>
				<th pSortableColumn="TopicDesc">Description<p-sortIcon field="TopicDesc"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="c_date">Last Updated<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="PersonCount"># of People<p-sortIcon field="PersonCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-PortalPanicAlertTopic>
			<tr [pSelectableRow]="PortalPanicAlertTopic" (dblclick)="onRowDblClick(PortalPanicAlertTopic)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopic.TopicCD }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopic.TopicDesc }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="PortalPanicAlertTopic.SchoolID > 0 ? 'Black' : 'Red'"
				>
					{{ PortalPanicAlertTopic.SchoolName }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="PortalPanicAlertTopic.Active == true ? 'Black' : 'Red'"
				>
					{{ PortalPanicAlertTopic.ActiveDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopic.c_dateDesc }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="PortalPanicAlertTopic.PersonCount > 0 ? 'Black' : 'Red'"
				>
					{{ PortalPanicAlertTopic.PersonCount }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>

<div *ngIf="SelectedPortalPanicAlertTopic != undefined">
	<caass-panic-alert-person-table [SelectedPortalPanicAlertTopic]="SelectedPortalPanicAlertTopic"></caass-panic-alert-person-table>
</div>
